import { LoadablePaint } from '@confluence/loadable';

export const LazyCalendarIcon = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CalendarIcon" */ '@atlaskit/icon/core/calendar'))
			.default,
});

export const LazyFeedbackIcon = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FeedbackIcon" */ '@atlaskit/icon/core/megaphone'))
			.default,
});
